import { escapeHtml } from "@emkit/builder-core";
export const FEATURES_DEFAULTS = {
    items: [
        {
            id: "f1",
            icon: "⚡",
            title: "Lightning fast",
            description: "Static HTML output loads instantly on any host.",
        },
        {
            id: "f2",
            icon: "🎨",
            title: "Visual editor",
            description: "Drag, drop, inspect. No code required to ship.",
        },
        {
            id: "f3",
            icon: "🔒",
            title: "Safe by default",
            description: "Sanitiser neutralises unsafe imports automatically.",
        },
        {
            id: "f4",
            icon: "📱",
            title: "Responsive",
            description: "Breakpoint switcher edits desktop / tablet / mobile independently.",
        },
        {
            id: "f5",
            icon: "🔄",
            title: "Undo anywhere",
            description: "Every edit goes through full undo/redo history.",
        },
        {
            id: "f6",
            icon: "💾",
            title: "JSON round-trip",
            description: "Export pages to JSON and import them again losslessly.",
        },
    ],
    columns: 3,
    style: "card",
    iconStyle: "badge",
    accent: "#111827",
    cardBackground: "#ffffff",
    textColor: "#0f172a",
    background: "transparent",
};
export const featuresWidget = {
    type: "features",
    defaultProps: FEATURES_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-features" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty features — add items in the inspector)</div>`;
        }
        const cols = props.columns ?? 3;
        const style = props.style ?? "card";
        const iconStyle = props.iconStyle ?? "badge";
        const accent = props.accent ?? "#111827";
        const cardBg = props.cardBackground ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const bg = props.background ?? "transparent";
        const gridStyle = [
            "display:grid",
            `grid-template-columns:repeat(${cols},minmax(0,1fr))`,
            "gap:24px",
            "max-width:1200px",
            "margin:0 auto",
            "font-family:inherit",
        ].join(";");
        const cardStyleBase = style === "card"
            ? `padding:24px;border-radius:12px;background:${cardBg};color:${text};border:1px solid rgba(0,0,0,0.08)`
            : `padding:8px 0;color:${text}`;
        const cells = items
            .map((it) => {
            let iconEl;
            if (iconStyle === "badge") {
                iconEl = `<div style="width:44px;height:44px;border-radius:10px;background:${accent};color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:22px;margin-bottom:16px">${escapeHtml(it.icon)}</div>`;
            }
            else if (iconStyle === "tint") {
                iconEl = `<div style="width:44px;height:44px;border-radius:10px;background:${accent}1a;color:${accent};display:inline-flex;align-items:center;justify-content:center;font-size:22px;margin-bottom:16px">${escapeHtml(it.icon)}</div>`;
            }
            else {
                iconEl = `<div style="font-size:28px;margin-bottom:12px;line-height:1">${escapeHtml(it.icon)}</div>`;
            }
            return `<div class="emk-feature" style="${cardStyleBase}">${iconEl}<h3 style="margin:0 0 8px;font-size:17px;font-weight:600;line-height:1.3">${escapeHtml(it.title)}</h3><p style="margin:0;font-size:15px;line-height:1.55;opacity:0.75">${escapeHtml(it.description)}</p></div>`;
        })
            .join("");
        return `<div class="emk-features" style="background:${bg};padding:20px 0"><div style="${gridStyle}">${cells}</div></div>`;
    },
};
//# sourceMappingURL=features.js.map